<div mat-dialog-title class="dialog-header">
    <h5>{{this.data.messageTitle}}</h5>
    <nb-icon mat-dialog-close icon="close-outline"></nb-icon>
</div>
<mat-dialog-content class="countdown">
    {{this.data.message+countdown}} seconds
</mat-dialog-content>